// extracted by mini-css-extract-plugin
export default {"showCorrectSelection":"Input_showCorrectSelection__DaxKc","showIncorrectSelection":"Input_showIncorrectSelection__v0jKr"};